import { useTheme } from "@emotion/react";

import { ICandyTheme } from "./ThemeBuilder/ICandyTheme";

export function useCandyTheme(): ICandyTheme {
    return useTheme().candy;
}
